import { useEffect, useState } from 'react'
import { Capacitor } from '@capacitor/core'
import { getDashboardGreetingKey } from '@/lib/dashboardGreeting'
import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'

/** Settings and the effective locale are resolved by the Members bootstrap before
 * this dashboard mounts. Use the same club timezone context as booking dates.
 * Foreground handlers update only the clock; MemberPortalContent owns data refresh. */
export function useMemberDashboardGreeting(timeZone) {
  const { t } = useOptionalPrivanaI18n()
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    let timer, listener, disposed = false
    const tick = () => {
      clearTimeout(timer)
      setNow(new Date())
      if (document.visibilityState !== 'hidden') {
        timer = setTimeout(tick, 60000 - Date.now() % 60000)
      }
    }
    const resume = () => { if (!disposed) tick() }
    const visible = () => {
      if (document.visibilityState === 'hidden') clearTimeout(timer)
      else resume()
    }
    document.addEventListener('visibilitychange', visible)
    window.addEventListener('focus', resume)
    if (Capacitor.isNativePlatform()) {
      import('@capacitor/app').then(({ App }) => App.addListener('appStateChange', ({ isActive }) => {
        if (isActive) resume()
        else clearTimeout(timer)
      })).then(handle => { if (disposed) handle.remove(); else listener = handle }).catch(() => {})
    }
    tick()
    return () => {
      disposed = true
      clearTimeout(timer)
      document.removeEventListener('visibilitychange', visible)
      window.removeEventListener('focus', resume)
      listener?.remove()
    }
  }, [])
  return t(getDashboardGreetingKey(timeZone, now))
}
